/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as LayoutRouteImport } from "./routes/_layout"
import { Route as LayoutIndexRouteImport } from "./routes/_layout/index"
import { Route as LayoutTokenizationRouteImport } from "./routes/_layout/tokenization"

const LayoutRoute = LayoutRouteImport.update({
  id: "/_layout",
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTokenizationRoute = LayoutTokenizationRouteImport.update({
  id: "/tokenization",
  path: "/tokenization",
  getParentRoute: () => LayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof LayoutIndexRoute
  "/tokenization": typeof LayoutTokenizationRoute
}
export interface FileRoutesByTo {
  "/tokenization": typeof LayoutTokenizationRoute
  "/": typeof LayoutIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_layout": typeof LayoutRouteWithChildren
  "/_layout/tokenization": typeof LayoutTokenizationRoute
  "/_layout/": typeof LayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: "/" | "/tokenization"
  fileRoutesByTo: FileRoutesByTo
  to: "/tokenization" | "/"
  id: "__root__" | "/_layout" | "/_layout/tokenization" | "/_layout/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_layout": {
      id: "/_layout"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_layout/": {
      id: "/_layout/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/tokenization": {
      id: "/_layout/tokenization"
      path: "/tokenization"
      fullPath: "/tokenization"
      preLoaderRoute: typeof LayoutTokenizationRouteImport
      parentRoute: typeof LayoutRoute
    }
  }
}

interface LayoutRouteChildren {
  LayoutTokenizationRoute: typeof LayoutTokenizationRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutTokenizationRoute: LayoutTokenizationRoute,
  LayoutIndexRoute: LayoutIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
